import { render, staticRenderFns } from "./ExtendedInformation.vue?vue&type=template&id=4cd976be"
import script from "./ExtendedInformation.vue?vue&type=script&lang=js"
export * from "./ExtendedInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports